import { render } from "./Browser-View.vue?vue&type=template&id=e46a3ac6&scoped=true"
import script from "./Browser-View.vue?vue&type=script&lang=js"
export * from "./Browser-View.vue?vue&type=script&lang=js"

import "./Browser-View.vue?vue&type=style&index=0&id=e46a3ac6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e46a3ac6"

export default script